import {
  AccordionContent,
  AccordionItem,
} from "@/components/reusables/ui/accordion"
import { PropertySearchAutocomplete } from "@/screens/loans/components/setup/PropertySearchAutocomplete"
import { Body, H5 } from "@/components/standard/BFText"
import type { BFDropDownOption } from "@/components/standard/BFDropDownPopover"
import { AccordionHeader } from "@/screens/loans/components/setup/AccordionHeader"
import WarningCircle from "phosphor-react-native/src/icons/WarningCircle"
import { ActivityIndicator, Pressable, View } from "react-native"

import { BFColors } from "@/constants/Colors"
import { Container } from "@/screens/rewards/components/Container"
import {
  useLoanContext,
  useNewLoanContext,
} from "@/screens/loans/components/LoanContext"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import MapPin from "phosphor-react-native/src/icons/MapPin"
import { SwitchPropertyPopup } from "@/screens/loans/components/SwitchPropertyPopup"
import { useState } from "react"

const AddressCard = ({ address }: { address: string }) => {
  const street = address?.split(",")[0]
  const rest = address?.split(",").slice(1).join(", ")
  return (
    <Container>
      <Horizontal className={"items-center"}>
        <View className={"mr-4"}>
          <MapPin size={24} />
        </View>
        <Vertical>
          <Body>{street}</Body>
          <Body>{rest?.trim()}</Body>
        </Vertical>
      </Horizontal>
    </Container>
  )
}

export const PropertyQuestions = () => {
  const { loanApplication } = useLoanContext()
  const { place, setPlace, placeLoadError } = useNewLoanContext()
  const [propertyPopupVisible, setPropertyPopupVisible] =
    useState<boolean>(false)

  const loading = place && !loanApplication?.property

  const address = loanApplication?.property?.fullAddress || place?.address
  const street = address?.split(",")[0]

  function onSelect(option: BFDropDownOption) {
    setPlace({ placeId: option.value, address: option.label })
  }

  return (
    <AccordionItem value={"property"}>
      <AccordionHeader
        text={"Property Address"}
        value={
          <View className={"flex-row gap-2 items-center"}>
            {loading && !placeLoadError && <ActivityIndicator size={"small"} />}
            {placeLoadError && <WarningCircle color={BFColors.redOrange} />}
            <H5
              color={placeLoadError ? "error" : "primaryLight"}
              numberOfLines={1}
              className={"text-ellipsis flex-1 max-w-[150px]"}
            >
              {street || ""}
            </H5>
          </View>
        }
      />
      <AccordionContent>
        {address && !placeLoadError ? (
          <Pressable
            testID={"address-card"}
            onPress={() => {
              setPropertyPopupVisible(true)
            }}
          >
            <AddressCard address={address} />
          </Pressable>
        ) : (
          <PropertySearchAutocomplete
            onSelect={onSelect}
            error={placeLoadError}
          />
        )}
      </AccordionContent>
      <SwitchPropertyPopup
        visible={propertyPopupVisible}
        onClose={() => {
          setPropertyPopupVisible(false)
        }}
      />
    </AccordionItem>
  )
}
